import styled from 'styled-components/macro';
import { colors, radius, transition } from 'css/constants';

const Button = styled.button`
  background-color: ${colors.blue};
  border: none;
  border-radius: ${radius}px;
  display: ${({ inline }) => (inline ? 'inline-block' : 'block')};
  text-decoration: none;
  text-align: center;
  user-select: none;
  outline: none;
  padding: ${({ small }) => (small ? '0.25em 0.5em' : '0.375rem 0.75rem')};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  min-width: ${({ small }) => !small && '8em'};
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  color: #fff;
  transition: ${transition};

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    background-color: ${colors.lightBlue};
  }

  &:focus {
    box-shadow: inset 0 0 2px rgb(0 0 0 / 33%);
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${colors.midGrey};
  }

  & svg {
    font-size: 1.25rem;
  }
`;

export const GhostButton = styled(Button)`
  color: ${colors.blue};
  border: 1px solid ${colors.blue};
  background-color: transparent;

  &:hover,
  &:focus,
  &:active {
    color: white;
    background-color: ${colors.blue};
  }

  &:disabled {
    color: ${colors.blue};
    background-color: transparent;
    opacity: 0.25;
  }
`;

export const IconButton = styled(GhostButton)`
  min-width: unset;
  padding: 0.5rem;
  line-height: 1em;
  border-radius: 5px;

  & svg {
    min-width: 1.25rem;
  }
`;

export const RemoveButton = styled(Button)`
  background-color: ${colors.red};

  &:hover,
  &:focus,
  &:active {
    background-color: ${colors.darkRed};
    border-color: ${colors.darkRed};
  }

  &:disabled {
    background-color: ${colors.midGrey};
    border-color: rgb(0 0 0 / 33%);
  }
`;

export const SecondaryButton = styled(Button)`
  background-color: ${colors.midGrey};
  color: ${colors.darkGrey};
`;

export default Button;
